// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrIconButton, MrIcon } from '@ion/components';

import { usePipelineIntegrationModalContext } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/context/pipeline-integration-modal-context';
import { PIPELINE_MODAL_OPTIONS } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-modal/PipelineModal';

const DEFAULT_BUTTON_PROPS = {
  variant: 'outlined',
  size: 'medium',
  text: 'Add Integration',
  Icon: <MrIcon id="start-icon" fontSize="small" />,
  testId: 'addIntegrationButton',
};

export default function AddIntegrationButton() {
  const { onOpenModal } = usePipelineIntegrationModalContext();
  const onClickAddButton = () => {
    onOpenModal(PIPELINE_MODAL_OPTIONS.addIntegration);
  };

  return <MrIconButton {...DEFAULT_BUTTON_PROPS} onClick={onClickAddButton} />;
}
